const backendUrls = {
  API_BASE: 'https://icecreamworld.top/api',
  SOCKET_URL: 'https://icecreamworld.top'
  // API_BASE: "http://localhost:5000/api",
  // SOCKET_URL: "http://localhost:5000"
};

export default backendUrls;
